import React, { Component } from 'react';
import { AccentColor } from 'helpers/AccentColorHelper';
import SlideDownAnimation from 'components/shared/SlideDownAnimation';
import SearchableSelect from 'components/shared/SearchableSelect';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { titleize } from 'helpers/Formatter';
import Checkbox from '@material-ui/core/Checkbox';
import { localize } from 'react-localize-redux';
import { media } from 'helpers/MediaHelper';
import styled from 'styled-components';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const StyledP = styled.p`
  display: inline-block;

  ${media.mobile`
    max-width: 240px;
  `};
`;

const styles = {
  sectionHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
  },
  city: {
    color: 'rgba(0,0,0,0.5)',
    fontSize: '11px',
  },
  listHeader: {
    padding: '5px 10px',
    overflow: 'hidden',
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
  listHeaderAction: {
    color: AccentColor(),
    fontSize: '12px',
    float: 'right',
  },
  listHeaderInfo: {
    fontSize: '12px',
    color: 'rgba(0,0,0,0.3)',
  },
  list: {
    maxHeight: '180px',
    overflow: 'auto',
  },
  listItem: {
    padding: '5px 10px',
  },
  itemLink: {
    color: AccentColor(),
    fontSize: '12px',
    float: 'right',
  },
  assignShowings: {
    float: 'right',
  },
  propertyDetails: {},
};

class AccessiblePropertiesForm extends Component {
  constructor(props) {
    super(props);
    let selectedProperties = {};
    let selectedShowingProperties = {};
    props.user.showing_properties &&
      props.user.showing_properties.forEach((property) => {
        selectedShowingProperties[property.value] = property;
      });
    props.user.properties.forEach((property) => {
      selectedProperties[property.value] = property;
    });
    this.state = {
      selectedProperties: selectedProperties,
      selectedShowingProperties: selectedShowingProperties,
      selectedCity: {
        label: this.translateText('landlordPortal.users.accessiblePropertiesForm.all'),
        value: 'all',
      },
      showPropertyFinder: false,
      filterText: '',
    };
  }

  translateText = (text) => this.props.translate(text).props.children;

  getCities = () => {
    let cities = this.props.properties.map((property) => property.city.toLowerCase());
    cities = Array.from(new Set(cities));
    cities = cities.map((city) => ({ label: titleize(city), value: city }));
    return [
      {
        label: this.translateText('landlordPortal.users.accessiblePropertiesForm.all'),
        value: 'all',
      },
      ...cities,
    ];
  };

  changeSelectedCity = (selectedCity) => {
    this.setState({ selectedCity });
  };

  getFilteredProperties = () => {
    return this.props.properties.filter((property) => {
      const currentCity = this.state.selectedCity.value;
      const currentFilterText = this.state.filterText.toLowerCase();
      return (
        (property.city.toLowerCase() === currentCity || currentCity === 'all') &&
        (currentFilterText === '' ||
          property.label.toLowerCase().indexOf(currentFilterText) !== -1) &&
        !(property.value in this.state.selectedProperties)
      );
    });
  };

  toggleShowingAvailable = (property, checked) => {
    let newSelection = { ...this.state.selectedShowingProperties };

    if (checked) {
      newSelection[property.value] = property;
    } else {
      delete newSelection[property.value];
    }

    this.setState({
      selectedShowingProperties: newSelection,
    });

    this.props.changeFormValue(
      this.props.formName,
      'showing_properties',
      Object.values(newSelection)
    );
  };

  selectAll = () => {
    let newSelection = { ...this.state.selectedProperties };
    this.getFilteredProperties().forEach((property) => {
      newSelection[property.value] = property;
    });
    this.setState({
      selectedProperties: newSelection,
      selectedShowingProperties: newSelection,
    });
    this.props.changeFormValue(this.props.formName, 'properties', Object.values(newSelection));
    this.props.changeFormValue(
      this.props.formName,
      'showing_properties',
      Object.values(newSelection)
    );
    if (this.props.onChange) {
      this.props.onChange(newSelection);
    }
  };

  selectOne = (property) => {
    let newSelection = { ...this.state.selectedProperties };
    newSelection[property.value] = property;
    this.setState({
      selectedProperties: newSelection,
      selectedShowingProperties: newSelection,
    });
    this.props.changeFormValue(this.props.formName, 'properties', Object.values(newSelection));
    this.props.changeFormValue(
      this.props.formName,
      'showing_properties',
      Object.values(newSelection)
    );
    if (this.props.onChange) {
      this.props.onChange(newSelection);
    }
  };

  deselectAll = () => {
    this.setState({
      selectedProperties: {},
      selectedShowingProperties: {},
    });
    this.props.changeFormValue(this.props.formName, 'properties', []);
    this.props.changeFormValue(this.props.formName, 'showing_properties', []);
    if (this.props.onChange) {
      this.props.onChange([]);
    }
  };

  deselectOne = (id) => {
    let newSelection = { ...this.state.selectedProperties };
    delete newSelection[id];
    this.setState({
      selectedProperties: newSelection,
      selectedShowingProperties: newSelection,
    });
    this.props.changeFormValue(this.props.formName, 'properties', Object.values(newSelection));
    this.props.changeFormValue(
      this.props.formName,
      'showing_properties',
      Object.values(newSelection)
    );
    if (this.props.onChange) {
      this.props.onChange(newSelection);
    }
  };

  changeFilterText = (event) => {
    this.setState({
      filterText: event.target.value,
    });
  };

  render() {
    return (
      <div>
        {this.renderSelectedPropertiesSection(this.props.user.user_type)}
        {!this.state.showPropertyFinder && (
          <div className="col-xs-12" style={{ padding: '10px', textAlign: 'center' }}>
            <button
              type="button"
              className="link-button"
              onClick={() => this.setState({ showPropertyFinder: true })}
            >
              {this.translateText('landlordPortal.users.accessiblePropertiesForm.assignMore')}
            </button>
          </div>
        )}
        <SlideDownAnimation>{this.renderPropertyFinder()}</SlideDownAnimation>
      </div>
    );
  }

  renderSelectedPropertiesSection = (userType) => {
    const { selectedProperties, selectedShowingProperties } = this.state;

    return (
      <div className="row">
        <div className="col-xs-12" style={{ padding: '0' }}>
          <div style={{ ...styles.listHeader, backgroundColor: '#e7f7e7' }}>
            <span style={styles.listHeaderInfo}>
              {Object.values(selectedProperties).length}{' '}
              {this.translateText('landlordPortal.users.accessiblePropertiesForm.propertyAssigned')}
            </span>
            {Object.values(selectedProperties).length > 0 && (
              <React.Fragment>
                <button
                  type="button"
                  className="link-button"
                  style={styles.listHeaderAction}
                  onClick={this.deselectAll}
                >
                  {this.translateText('landlordPortal.users.accessiblePropertiesForm.deselectAll')}
                </button>
                <RenderIfToggleOn
                  toggle="showings.assign_showings"
                  dontRenderIf={userType !== 'Agent'}
                >
                  <span style={{ ...styles.listHeaderInfo, float: 'right', marginRight: '16px' }}>
                    {this.translateText(
                      'landlordPortal.users.accessiblePropertiesForm.assignShowings'
                    )}
                  </span>
                </RenderIfToggleOn>
              </React.Fragment>
            )}
          </div>
          <div style={styles.list}>
            {Object.values(selectedProperties).map((property) => {
              return (
                <div style={styles.listItem} key={`key_${property.value}`}>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.deselectOne(property.value)}
                    style={styles.itemLink}
                  >
                    {this.translateText('landlordPortal.users.accessiblePropertiesForm.deselect')}
                  </button>
                  <StyledP style={styles.propertyDetails}>
                    {property.label} - <span style={styles.city}>{property.city}</span>
                  </StyledP>
                  <RenderIfToggleOn
                    toggle="showings.assign_showings"
                    dontRenderIf={userType !== 'Agent'}
                  >
                    <span style={styles.assignShowings}>
                      <Checkbox
                        style={{ padding: 0, marginTop: '-3px', marginRight: '32px' }}
                        checked={!!selectedShowingProperties[property.value]}
                        onChange={(event) =>
                          this.toggleShowingAvailable(property, event.target.checked)
                        }
                      />
                    </span>
                  </RenderIfToggleOn>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  renderPropertyFinder = () => {
    if (!this.state.showPropertyFinder) return null;

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.translateText('landlordPortal.users.accessiblePropertiesForm.findProperties')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ margin: '15px 0 0' }}>
            <TextField
              label={this.translateText(
                'landlordPortal.users.accessiblePropertiesForm.filterByName'
              )}
              value={this.state.filterText}
              onChange={this.changeFilterText}
            />
          </div>
          <div className="col-xs-12" style={{ margin: '15px 0' }}>
            <SearchableSelect
              name="assigned_agent"
              data={this.getCities()}
              label={this.translateText(
                'landlordPortal.users.accessiblePropertiesForm.filterByRegion'
              )}
              fullWidth
              onChange={this.changeSelectedCity}
              value={this.state.selectedCity}
              menuStyle={{ minWidth: '250px', fontSize: '14px' }}
            />
          </div>
          {this._renderFilteredProperties()}
        </div>
      </div>
    );
  };

  _renderFilteredProperties = () => {
    const filteredProperties = this.getFilteredProperties();

    return (
      <div className="col-xs-12" style={{ padding: '0' }}>
        <div style={{ ...styles.listHeader, backgroundColor: '#e7f2f7' }}>
          <span style={styles.listHeaderInfo}>
            {filteredProperties.length}{' '}
            {this.translateText('landlordPortal.users.accessiblePropertiesForm.propertiesFound')}{' '}
          </span>
          {filteredProperties.length > 0 && (
            <button
              type="button"
              className="link-button"
              style={styles.listHeaderAction}
              onClick={this.selectAll}
            >
              {this.translateText('landlordPortal.users.accessiblePropertiesForm.selectAll')}
            </button>
          )}
        </div>
        <div style={styles.list}>
          {filteredProperties.map((property) => {
            return (
              <div key={`key_${property.value}`} style={styles.listItem}>
                <span>
                  {property.label} - <span style={styles.city}>{titleize(property.city)}</span>
                </span>
                <button
                  type="button"
                  className="link-button"
                  style={styles.itemLink}
                  onClick={() => this.selectOne(property)}
                >
                  {this.translateText('landlordPortal.users.accessiblePropertiesForm.select')}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
}

export default compose(
  connect(
    (state, ownProps) => {
      return {
        form: ownProps.formName,
      };
    },
    {
      changeFormValue: change,
    }
  ),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(localize()(AccessiblePropertiesForm));
